import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { ManageAdminsComponent } from 'src/app/components/main-content/admin/manage-admins/manage-admins.component';
import { ManageQuickUrlsComponent } from 'src/app/components/main-content/admin/manage-quick-urls/manage-quick-urls.component';
import { DesignLookupComponent } from 'src/app/components/main-content/design-lookup/design-lookup.component';
import { LoginFailedComponent } from 'src/app/components/main-content/errors/login-failed/login-failed.component';
import { NotFoundComponent } from 'src/app/components/main-content/errors/not-found/not-found.component';
import { UnauthorizedComponent } from 'src/app/components/main-content/errors/unauthorised/unauthorized.component';
import { IntroComponent } from 'src/app/components/main-content/intro/intro.component';
import { RoleSelectionComponent } from 'src/app/components/main-content/role-selection/role-selection.component';
import { WorklistPageComponent } from 'src/app/components/main-content/worklist-page/worklist-page.component';
import { AdminGuard, RoleEnabledGuard } from 'src/app/guards';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'data/design',
  },
  {
    canActivate: [MsalGuard, RoleEnabledGuard],
    component: IntroComponent,
    path: 'data/design',
    pathMatch: 'full',
  },
  {
    canActivate: [MsalGuard, RoleEnabledGuard],
    component: DesignLookupComponent,
    path: 'data/design/:designId',
  },
  {
    canActivate: [MsalGuard, RoleEnabledGuard],
    component: WorklistPageComponent,
    path: 'data/worklist',
  },
  {
    canActivate: [MsalGuard, RoleEnabledGuard],
    component: RoleSelectionComponent,
    path: 'select-role',
  },
  {
    canActivate: [MsalGuard, RoleEnabledGuard, AdminGuard],
    component: ManageAdminsComponent,
    path: 'admin/admins',
  },
  {
    canActivate: [MsalGuard, RoleEnabledGuard, AdminGuard],
    component: ManageQuickUrlsComponent,
    path: 'admin/urls',
  },
  {
    component: UnauthorizedComponent,
    path: 'error/403',
  },
  {
    component: LoginFailedComponent,
    path: 'error/login-failed',
  },
  {
    component: NotFoundComponent,
    path: 'error/404',
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];

const isIframe = BrowserUtils.isInIframe() && !window.opener;

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: !isIframe ? 'enabledNonBlocking' : 'disabled',
    }),
  ],
})
export class AppRoutingModule {}
